/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/replace.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * The function substitutes in the string `str` any match of the regular expression `regex`
 * with the replacement string `newStr`.
 *
 * @example
 * ROW str = "Hello World"
 * | EVAL str = REPLACE(str, "World", "Universe")
 *
 * @example
 * ROW str = "Hello World"
 * | EVAL str = REPLACE(str, "\\\\s+", "")
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'replace',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'regex',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'newString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'regex',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'newString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'regex',
          type: 'text',
          optional: false,
        },
        {
          name: 'newString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'regex',
          type: 'text',
          optional: false,
        },
        {
          name: 'newString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'regex',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'newString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'regex',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'newString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'regex',
          type: 'text',
          optional: false,
        },
        {
          name: 'newString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'regex',
          type: 'text',
          optional: false,
        },
        {
          name: 'newString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
